// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Form, FormGroup, Label, Button } from "@components";
import { Field, reduxForm } from "redux-form";
import { TextField } from "@components/form";
import type { FormProps } from "redux-form";

type OwnProps = $Exact<{
  labelMsgId: string,
  onSubmit: Function,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export const SearchEmployeeForm = (props: Props) => (
  <Form onSubmit={props.handleSubmit}>
    <FormGroup>
      <Label for="username">{props.t(props.labelMsgId)}</Label>
      <Field name="lastName" autoComplete={"off"} component={TextField} />
    </FormGroup>
    <Button className="d-none" type="submit">
      Hidden button
    </Button>
  </Form>
);

SearchEmployeeForm.defaultProps = {
  labelMsgId: "SEARCH_BY_USERNAME",
};

export default reduxForm({
  form: "add-employee-modal",
})(localize()(SearchEmployeeForm));
